import { SpaceExtraSeatsFeature, SpacesFeature } from '@/shared/types/Settings';
import { UpgradeAlert } from '@/shared/ui/UpgradeAlert';

import { getUpgradeAlertText } from '../lib/getUpgradeAlertText';

export type TeamspaceUpgradeAlertProps = {
  extraSeatsFeature?: SpaceExtraSeatsFeature;
  hasTrialPlan?: boolean;
  spacesFeature: SpacesFeature;
  onClick: () => void;
};

export const TeamspaceUpgradeAlert = ({ extraSeatsFeature, hasTrialPlan, spacesFeature, onClick }: TeamspaceUpgradeAlertProps) => {
  const extraSeats = extraSeatsFeature?.metadata?.quantity || 0;

  let buttonText = 'Add more';

  if (hasTrialPlan) {
    buttonText = 'Get Started';
  }

  return <UpgradeAlert buttonText={buttonText} text={getUpgradeAlertText(spacesFeature, extraSeats)} onClick={onClick} />;
};
